module.exports = __webpack_public_path__ + "3de404d56e095aa66e73404bd36da196.MP3";